module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('loading-screen', {
    attrs: {
      "show": _vm.displayLoadingScreen,
      "appBackground": true,
      "autoStop": true
    },
    on: {
      "stopLoadingScreen": function($event) {
        _vm.displayLoadingScreen = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-header navbar navbar-fixed-top"
  }, [_c('div', {
    staticClass: "page-header-inner"
  }, [_vm._m(0, false, false), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "top-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav pull-right"
  }, [_c('li', {
    staticClass: "dropdown dropdown-user left",
    on: {
      "click": function($event) {
        _vm.logOut()
      }
    }
  }, [_vm._m(2, false, false)]), _vm._v(" "), _c('li', {
    staticClass: "dropdown dropdown-quick-sidebar-toggler width-auto",
    on: {
      "click": function($event) {
        _vm.toggleQuickSidebar($event)
      }
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle location-panel width-auto"
  }, [_vm._m(3, false, false), _vm._v(" "), (_vm.activeLocation.display_name) ? _c('div', {
    staticClass: "location-name-container"
  }, [_c('span', {
    staticClass: "business-name"
  }, [_vm._v(_vm._s(_vm.$root.activeUser.name))]), _vm._v(" "), _c('span', {
    staticClass: "business-location-name"
  }, [_vm._v(_vm._s(_vm.activeLocation.display_name))])]) : _c('div', {
    staticClass: "location-name-container"
  }, [_c('span', {
    staticClass: "business-name big"
  }, [_vm._v(_vm._s(_vm.$root.activeUser.name))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    staticClass: "page-sidebar-wrapper"
  }, [_c('div', {
    staticClass: "page-sidebar navbar-collapse collapse"
  }, [_c('ul', {
    staticClass: "page-sidebar-menu page-header-fixed",
    attrs: {
      "data-keep-expand": "false"
    }
  }, [(_vm.$root.permissions['analytics overview read'] ||
    _vm.$root.permissions['analytics store read'] ||
    _vm.$root.permissions['analytics item read'] ||
    _vm.$root.permissions['analytics user read']
  ) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'analytics'
    },
    attrs: {
      "id": "store_manager_link"
    }
  }, [_c('a', {
    staticClass: "nav-link nav-toggle unselectable",
    on: {
      "click": function($event) {
        _vm.toggleNavigation($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-line-chart"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Analytics")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.$root.permissions['analytics overview read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'analytics' && _vm.currentSubRoute === 'overview'
    },
    attrs: {
      "id": "store_manager_create_new_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/analytics/overview"
    }
  }, [_c('i', {
    staticClass: "fa fa-compress"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Overview")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['analytics store read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'analytics' && _vm.currentSubRoute === 'locationsales'
    },
    attrs: {
      "id": "store_manager_applications_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/analytics/locationsales"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Store Sales")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['analytics item read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'analytics' && _vm.currentSubRoute === 'itemsales'
    },
    attrs: {
      "id": "item_sales_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/analytics/itemsales"
    }
  }, [_c('i', {
    staticClass: "fa fa-th-large"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Item Sales")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['analytics user read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'analytics' && _vm.currentSubRoute === 'useranalytics'
    },
    attrs: {
      "id": "user_analytics_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/analytics/useranalytics"
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("User Analytics")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['approvals read'] ||
    _vm.$root.permissions['approvals request read'] ||
    _vm.$root.permissions['list role'] ||
    _vm.$root.permissions['list permission'] ||
    _vm.$root.permissions['approvals modules read']
  ) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'approvals'
    },
    attrs: {
      "id": "admin_manager_link"
    }
  }, [_c('a', {
    staticClass: "nav-link nav-toggle unselectable",
    on: {
      "click": function($event) {
        _vm.toggleNavigation($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Approvals Manager\n\t\t\t\t\t\t\t\t\t"), (_vm.$root.requestsPending) ? _c('i', {
    staticClass: "fa fa-circle danger"
  }) : _vm._e()])]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.$root.permissions['approvals read'] ||
    _vm.$root.permissions['approvals request read']
  ) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'approvals' && _vm.currentSubRoute === 'approvals'
    },
    attrs: {
      "id": "admin_manager_approvals_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/approvals/approvals"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Approvals")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['list role']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'approvals' && _vm.currentSubRoute === 'roles'
    },
    attrs: {
      "id": "admin_manager_roles_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/approvals/roles"
    }
  }, [_c('i', {
    staticClass: "fa fa-id-badge"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Roles")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['list permission']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'approvals' && _vm.currentSubRoute === 'permissions'
    },
    attrs: {
      "id": "admin_manager_permissions_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/approvals/permissions"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Permissions")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['approvals modules read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'approvals' && _vm.currentSubRoute === 'modules'
    },
    attrs: {
      "id": "admin_manager_modules_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/approvals/modules"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Modules")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['admin brand_admins read'] ||
    _vm.$root.permissions['admin location_managers read'] ||
    _vm.$root.permissions['admin oma_users read'] ||
    _vm.$root.permissions['admin store_app_users read']
  ) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'admin'
    },
    attrs: {
      "id": "admin_manager_link"
    }
  }, [_c('a', {
    staticClass: "nav-link nav-toggle unselectable",
    on: {
      "click": function($event) {
        _vm.toggleNavigation($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cogs"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Admin Manager")])]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.$root.permissions['admin brand_admins read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'admin' && _vm.currentSubRoute === 'brand_admins'
    },
    attrs: {
      "id": "store_manager_create_new_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/admin/brand_admins"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Brand Admins")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['admin location_managers read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'admin' && _vm.currentSubRoute === 'location_managers'
    },
    attrs: {
      "id": "store_manager_create_new_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/admin/location_managers"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Location Managers")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['admin oma_users read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'admin' && _vm.currentSubRoute === 'OMA_users'
    },
    attrs: {
      "id": "store_manager_applications_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/admin/OMA_users"
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("OMA Users")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['admin store_app_users read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'admin' && _vm.currentSubRoute === 'store_app_users'
    },
    attrs: {
      "id": "store_manager_applications_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/admin/store_app_users"
    }
  }, [_c('i', {
    staticClass: "fa fa-tablet"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Store App Users")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['stores info read'] ||
    _vm.$root.permissions['stores info create'] ||
    _vm.$root.permissions['stores groups read'] ||
    _vm.$root.permissions['stores amenities read'] ||
    _vm.$root.permissions['stores order_settings read']
  ) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'store_manager'
    },
    attrs: {
      "id": "store_manager_link"
    }
  }, [_c('a', {
    staticClass: "nav-link nav-toggle unselectable",
    on: {
      "click": function($event) {
        _vm.toggleNavigation($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Stores Manager")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.$root.permissions['stores info create']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'store_manager' && _vm.currentSubRoute === 'create_new'
    },
    attrs: {
      "id": "store_manager_create_new_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/store_manager/create_new"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Create New Store")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['stores groups read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'store_manager' && _vm.currentSubRoute === 'store_groups'
    },
    attrs: {
      "id": "store_manager_applications_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/store_manager/store_groups"
    }
  }, [_c('i', {
    staticClass: "fa fa-sitemap"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Store Groups")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['stores info read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'store_manager' && (_vm.currentSubRoute === 'stores' || _vm.currentSubRoute === 'edit_store')
    },
    attrs: {
      "id": "store_manager_applications_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/store_manager/stores"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Stores")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['stores amenities read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'store_manager' && _vm.currentSubRoute === 'amenities'
    },
    attrs: {
      "id": "store_manager_amenities_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/store_manager/amenities"
    }
  }, [_c('i', {
    staticClass: "fa fa-wifi"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Amenities")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['stores order_settings read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'store_manager' && _vm.currentSubRoute === 'order_settings'
    },
    attrs: {
      "id": "store_manager_order_settings_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/store_manager/order_settings"
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Order Settings")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['news_feed read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'news_feed'
    }
  }, [_c('router-link', {
    staticClass: "nav-link nav-toggle",
    attrs: {
      "to": "/app/news_feed"
    }
  }, [_c('i', {
    staticClass: "fa fa-newspaper-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("News Feed")]), _vm._v(" "), _c('span', {
    staticClass: "selected"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['social_feed read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'social_feed'
    }
  }, [_c('router-link', {
    staticClass: "nav-link nav-toggle",
    attrs: {
      "to": "/app/social_feed"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Social Feed")]), _vm._v(" "), _c('span', {
    staticClass: "selected"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['tax tax_classes read'] ||
    _vm.$root.permissions['tax item_types read']
  ) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'tax_manager'
    },
    attrs: {
      "id": "tax_manager_link"
    }
  }, [_c('a', {
    staticClass: "nav-link nav-toggle unselectable",
    on: {
      "click": function($event) {
        _vm.toggleNavigation($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Tax Manager")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.$root.permissions['tax tax_classes read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'tax_manager' && _vm.currentSubRoute === 'tax_classes'
    },
    attrs: {
      "id": "tax_manager_tax_classes_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/tax_manager/tax_classes"
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Tax Classes")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['tax item_types read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'tax_manager' && _vm.currentSubRoute === 'item_types'
    },
    attrs: {
      "id": "tax_manager_item_types_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/tax_manager/item_types"
    }
  }, [_c('i', {
    staticClass: "fa fa-glass"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Item Types")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['menu_manager menus read'] ||
    _vm.$root.permissions['menu_manager tiers read'] ||
    _vm.$root.permissions['menu_manager modifiers read'] ||
    _vm.$root.permissions['menu_manager tags read'] ||
    _vm.$root.permissions['menu_manager portions read'] ||
    _vm.$root.permissions['menu_manager options read'] ||
    _vm.$root.permissions['menu_manager attributes read']
  ) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'menu_manager'
    },
    attrs: {
      "id": "menu_manager_link"
    }
  }, [_c('a', {
    staticClass: "nav-link nav-toggle unselectable",
    on: {
      "click": function($event) {
        _vm.toggleNavigation($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cutlery"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Menu Manager")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.$root.permissions['menu_manager menus read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'menu_manager' && (_vm.currentSubRoute === 'menus' || _vm.currentSubRoute === 'categories' || _vm.currentSubRoute === 'items')
    },
    attrs: {
      "id": "menu_manager_menus_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/menu_manager/menus"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Menus")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['menu_manager tiers read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'menu_manager' && _vm.currentSubRoute === 'menu_tiers'
    },
    attrs: {
      "id": "menu_manager_menu_tiers_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/menu_manager/menu_tiers"
    }
  }, [_c('i', {
    staticClass: "fa fa-sitemap"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Menu Tiers")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['menu_manager modifiers read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'menu_manager' && (_vm.currentSubRoute === 'modifiers' || _vm.currentSubRoute === 'modifier_items')
    },
    attrs: {
      "id": "menu_manager_modifiers_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/menu_manager/modifiers"
    }
  }, [_c('i', {
    staticClass: "fa fa-cogs"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Modifiers")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['menu_manager tags read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'menu_manager' && _vm.currentSubRoute === 'tags'
    },
    attrs: {
      "id": "menu_manager_tags_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/menu_manager/tags"
    }
  }, [_c('i', {
    staticClass: "fa fa-tags"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Tags")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['menu_manager portions read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'menu_manager' && _vm.currentSubRoute === 'portions'
    },
    attrs: {
      "id": "menu_manager_portions_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/menu_manager/portions"
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Portions")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['menu_manager options read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'menu_manager' && _vm.currentSubRoute === 'options'
    },
    attrs: {
      "id": "menu_manager_options_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/menu_manager/options"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-ul"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Options")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['menu_manager attributes read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'menu_manager' && _vm.currentSubRoute === 'item_attributes'
    },
    attrs: {
      "id": "menu_manager_item_attributes_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/menu_manager/item_attributes"
    }
  }, [_c('i', {
    staticClass: "fa fa-sticky-note-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Attributes")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['printers read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'printers'
    },
    attrs: {
      "id": "printers_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link nav-toggle",
    attrs: {
      "to": '/app/printers'
    }
  }, [_c('i', {
    staticClass: "icon-printer"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Printers")]), _vm._v(" "), _c('span', {
    staticClass: "selected"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['user_manager users read'] ||
    _vm.$root.permissions['user_manager user_groups read'] ||
    _vm.$root.permissions['user_manager attributes read']
  ) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'user_manager'
    },
    attrs: {
      "id": "user_manager_link"
    }
  }, [_c('a', {
    staticClass: "nav-link nav-toggle unselectable",
    on: {
      "click": function($event) {
        _vm.toggleNavigation($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Users Manager")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.$root.permissions['user_manager users read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'user_manager' && _vm.currentSubRoute === 'users'
    },
    attrs: {
      "id": "user_manager_applications_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/user_manager/users"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Users")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['user_manager user_groups read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'user_manager' && _vm.currentSubRoute === 'user_groups'
    },
    attrs: {
      "id": "user_manager_applications_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/user_manager/user_groups"
    }
  }, [_c('i', {
    staticClass: "fa fa-sitemap"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("User Groups")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['user_manager attributes read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'user_manager' && _vm.currentSubRoute === 'user_attributes'
    },
    attrs: {
      "id": "user_attributes_applications_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/user_manager/user_attributes"
    }
  }, [_c('i', {
    staticClass: "fa fa-sticky-note-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Attributes")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['faq user read'] ||
    _vm.$root.permissions['faq store read']
  ) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'faq'
    },
    attrs: {
      "id": "faq_link"
    }
  }, [_c('a', {
    staticClass: "nav-link nav-toggle unselectable",
    on: {
      "click": function($event) {
        _vm.toggleNavigation($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comments"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("FAQ")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.$root.permissions['faq user read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'faq' && _vm.currentSubRoute === 'users'
    },
    attrs: {
      "id": "faq_users_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/faq/users"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Users")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['faq store read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'faq' && _vm.currentSubRoute === 'stores'
    },
    attrs: {
      "id": "faq_stores_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/faq/stores"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Stores")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['gallery read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'gallery'
    }
  }, [_c('router-link', {
    staticClass: "nav-link nav-toggle",
    attrs: {
      "to": "/app/gallery"
    }
  }, [_c('i', {
    staticClass: "fa fa-image"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Gallery")]), _vm._v(" "), _c('span', {
    staticClass: "selected"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['loyalty base_rule read'] ||
    _vm.$root.permissions['loyalty promotion_rules read'] ||
    _vm.$root.permissions['reward_tiers read']
  ) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'loyalty'
    },
    attrs: {
      "id": "loyalty_link"
    }
  }, [_c('a', {
    staticClass: "nav-link nav-toggle unselectable",
    on: {
      "click": function($event) {
        _vm.toggleNavigation($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Loyalty")]), _vm._v(" "), _c('span', {
    staticClass: "selected"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.$root.permissions['loyalty base_rule read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'loyalty' && _vm.currentSubRoute === 'base_rule'
    },
    attrs: {
      "id": "faq_users_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/loyalty/base_rule"
    }
  }, [_c('i', {
    staticClass: "fa fa-paperclip"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Base Rule")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['loyalty promotion_rules read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'loyalty' && _vm.currentSubRoute === 'promotion_rules'
    },
    attrs: {
      "id": "faq_users_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/loyalty/promotion_rules"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-ol"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Promotion Rules")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['reward_tiers read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'loyalty' && _vm.currentSubRoute === 'rewards'
    },
    attrs: {
      "id": "faq_users_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/loyalty/rewards"
    }
  }, [_c('i', {
    staticClass: "fa fa-gift"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Rewards")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['promocodes read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'promocodes'
    }
  }, [_c('router-link', {
    staticClass: "nav-link nav-toggle",
    attrs: {
      "to": "/app/promocodes"
    }
  }, [_c('i', {
    staticClass: "fa fa-scissors"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Promo codes")]), _vm._v(" "), _c('span', {
    staticClass: "selected"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['promotions read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'promotions'
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/promotions"
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Promotions")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [(_vm.$root.permissions['promotions geolocations read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'promotions' && _vm.currentSubRoute === 'geolocations'
    },
    attrs: {
      "id": "promotions_geolocations_link"
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/app/promotions/geolocations"
    }
  }, [_c('i', {
    staticClass: "fa fa-compass"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Geolocations")])])], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.$root.permissions['localization read']) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.currentRoute === 'localization'
    }
  }, [_c('router-link', {
    staticClass: "nav-link nav-toggle",
    attrs: {
      "to": "/app/localization"
    }
  }, [_c('i', {
    staticClass: "fa fa-language"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Localization")]), _vm._v(" "), _c('span', {
    staticClass: "selected"
  })])], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-quick-sidebar-wrapper",
    attrs: {
      "data-close-on-body-click": "false"
    }
  }, [_c('a', {
    staticClass: "page-quick-sidebar-toggler",
    on: {
      "click": function($event) {
        _vm.toggleQuickSidebar($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })]), _vm._v(" "), _c('div', {
    staticClass: "page-quick-sidebar"
  }, [_c('div', [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active page-quick-sidebar-chat"
  }, [_c('div', {
    staticClass: "page-quick-sidebar-chat-users active-business",
    attrs: {
      "data-rail-color": "#ddd",
      "data-wrapper-class": "page-quick-sidebar-list"
    }
  }, [_c('ul', {
    staticClass: "media-list list-items"
  }, [_c('li', {
    staticClass: "media selected-location current-location"
  }, [_c('img', {
    staticClass: "media-object",
    attrs: {
      "src": require("../assets/img/app/logo-refresh.png"),
      "alt": "..."
    }
  }), _vm._v(" "), (!_vm.activeLocation.display_name) ? _c('div', {
    staticClass: "media-status"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  })]) : _vm._e(), _vm._v(" "), (_vm.activeLocation.display_name) ? _c('div', {
    staticClass: "media-status deactivate-location-dot-top",
    on: {
      "click": function($event) {
        _vm.unselectLocation($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v(_vm._s(_vm.$root.activeUser.name))]), _vm._v(" "), (!_vm.activeLocation.display_name) ? _c('div', {
    staticClass: "media-heading-sub"
  }, [_vm._v("Master Account Selected")]) : _c('div', {
    staticClass: "media-heading-sub"
  }, [_vm._v(_vm._s(_vm.activeLocation.display_name))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "padding-box"
  }, [(_vm.noRecordsError.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('span', [_vm._v(_vm._s(_vm.noRecordsError))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationSearch.search),
      expression: "locationSearch.search"
    }],
    staticClass: "form-control input-sm padding-right-20",
    class: {
      'edited': _vm.locationSearch.search.length
    },
    attrs: {
      "type": "text",
      "id": "location_search"
    },
    domProps: {
      "value": (_vm.locationSearch.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationSearch, "search", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.locationSearch.search.length) ? _c('i', {
    staticClass: "fa fa-times clear-icon",
    on: {
      "click": function($event) {
        _vm.clearSearch()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('label', {
    attrs: {
      "for": "location_search"
    }
  }, [_vm._v("Search All Stores")]), _vm._v(" "), _c('span', {
    staticClass: "help-block persist"
  }, [(_vm.searchError.length) ? _c('span', [_vm._v(_vm._s(_vm.searchError))]) : _c('span', [_vm._v("Search by Store Name or Store Address.")])])])]), _vm._v(" "), (_vm.filteredLocationsPaginated.length) ? _c('div', {
    staticClass: "margin-top-30"
  }, [_c('h3', {
    staticClass: "list-heading location-panel-heading blue"
  }, [_vm._v("Search Results")]), _vm._v(" "), (!_vm.searchError.length) ? _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active page-quick-sidebar-chat scrollable"
  }, [_c('div', {
    staticClass: "page-quick-sidebar-chat-users",
    attrs: {
      "data-rail-color": "#ddd",
      "data-wrapper-class": "page-quick-sidebar-list"
    }
  }, [_c('ul', {
    staticClass: "media-list list-items"
  }, _vm._l((_vm.filteredLocationsPaginated), function(location) {
    return _c('li', {
      key: location.id,
      staticClass: "media",
      on: {
        "click": function($event) {
          _vm.selectLocation(location)
        }
      }
    }, [(location.id === _vm.activeLocation.id) ? _c('div', {
      staticClass: "media-status",
      on: {
        "click": function($event) {
          _vm.unselectLocation($event)
        }
      }
    }, [_vm._m(4, true, false)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h4', {
      staticClass: "media-heading"
    }, [_vm._v(_vm._s(location.display_name))]), _vm._v(" "), _c('div', {
      staticClass: "media-heading-sub"
    }, [_vm._v(_vm._s(location.address_line_1))])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "pagination-wrapper"
  }, [_c('div', {
    staticClass: "pagination-arrow",
    class: {
      'disabled': _vm.currentPageFiltered === 1
    },
    on: {
      "click": function($event) {
        _vm.goToPreviousPageFiltered()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pagination-arrow",
    class: {
      'disabled': _vm.currentPageFiltered === _vm.lastPageFiltered
    },
    on: {
      "click": function($event) {
        _vm.goToNextPageFiltered()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])]) : _vm._e()]) : _c('div', {
    staticClass: "margin-top-30"
  }, [_c('h3', {
    staticClass: "list-heading location-panel-heading blue"
  }, [_vm._v("Stores")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active page-quick-sidebar-chat scrollable"
  }, [_c('div', {
    staticClass: "page-quick-sidebar-chat-users",
    attrs: {
      "data-rail-color": "#ddd",
      "data-wrapper-class": "page-quick-sidebar-list"
    }
  }, [_c('ul', {
    staticClass: "media-list list-items"
  }, [(_vm.activeLocation && _vm.activeLocation.id) ? _c('li', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-status",
    on: {
      "click": function($event) {
        _vm.unselectLocation($event)
      }
    }
  }, [_vm._m(5, false, false)]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v(_vm._s(_vm.activeLocation.display_name))]), _vm._v(" "), _c('div', {
    staticClass: "media-heading-sub"
  }, [_vm._v(_vm._s(_vm.activeLocation.address_line_1))])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.locations), function(location) {
    return (_vm.locations.length) ? _c('li', {
      key: location.id,
      staticClass: "media",
      on: {
        "click": function($event) {
          _vm.selectLocation(location)
        }
      }
    }, [_c('div', {
      staticClass: "media-body"
    }, [_c('h4', {
      staticClass: "media-heading"
    }, [_vm._v(_vm._s(location.display_name))]), _vm._v(" "), _c('div', {
      staticClass: "media-heading-sub"
    }, [_vm._v(_vm._s(location.address_line_1))])])]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lastPage > 1),
      expression: "lastPage > 1"
    }],
    staticClass: "pagination-wrapper"
  }, [_c('div', {
    staticClass: "pagination-arrow",
    class: {
      'disabled': _vm.currentPage === 1
    },
    on: {
      "click": function($event) {
        _vm.goToPreviousPage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pagination-arrow",
    class: {
      'disabled': _vm.currentPage === _vm.lastPage
    },
    on: {
      "click": function($event) {
        _vm.goToNextPage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])]), _vm._v(" "), (!_vm.locations.length) ? _c('div', {
    staticClass: "padding-box"
  }, [_vm._m(6, false, false)]) : _vm._e()])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-logo"
  }, [_c('a', [_c('img', {
    staticClass: "logo-default logo-unoapp",
    attrs: {
      "src": require("../assets/img/app/unoapp-commerce-logo.png"),
      "alt": "logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu-toggler sidebar-toggler"
  }, [_c('span')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "menu-toggler responsive-toggler",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle log-out-button",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('span', {
    staticClass: "username username-hide-on-mobile"
  }, [_vm._v("Log out")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-container"
  }, [_c('img', {
    staticClass: "business-logo",
    attrs: {
      "src": require("../assets/img/app/logo-refresh.png"),
      "width": "38",
      "height": "38"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "active-location-dots"
  }, [_c('div', {
    staticClass: "active-location-dot"
  }, [_c('i', {
    staticClass: "fa fa-circle blue"
  })]), _vm._v(" "), _c('div', {
    staticClass: "deactivate-location-dot"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "active-location-dots"
  }, [_c('div', {
    staticClass: "active-location-dot"
  }, [_c('i', {
    staticClass: "fa fa-circle blue"
  })]), _vm._v(" "), _c('div', {
    staticClass: "deactivate-location-dot"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info"
  }, [_c('span', [_vm._v("There are no store locations for this application.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-353318bf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 697
// module chunks = 0